import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api";
import {
  FiChevronDown,
  FiHelpCircle,
  FiArrowRight,
} from "react-icons/fi";

const FAQPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        setLoading(true);
        setError(false);

        // بدون limit؛ دریافت همه سوالات فعال
        const response = await api.get("/home/faq/");

        setFaqs(response.data);
      } catch (err) {
        console.error("خطا در دریافت همه سوالات متداول:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  const toggleAccordion = (index) => {
    setOpenIndex((previousIndex) =>
      previousIndex === index ? null : index
    );
  };

  return (
    <main
      dir="rtl"
      className="min-h-screen bg-gray-50 py-8 sm:py-12"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          className="mb-5 inline-flex items-center gap-2 text-sm font-medium text-[#1E3A5F] transition-colors hover:text-[#162d4a]"
        >
          <FiArrowRight className="h-4 w-4" />
          بازگشت به صفحه اصلی
        </Link>

        <section className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <header className="border-b border-gray-100 px-4 py-7 text-center sm:px-6">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#1E3A5F]/10 text-[#1E3A5F]">
              <FiHelpCircle className="h-6 w-6" />
            </div>

            <h1 className="mt-4 text-xl font-bold text-gray-900 sm:text-2xl">
              سوالات متداول
            </h1>

            <p className="mt-2 text-sm leading-7 text-gray-500 sm:text-base">
              پاسخ سوالات پرتکرار درباره خرید، سفارش، ارسال و خدمات سازین
            </p>
          </header>

          <div className="px-4 py-5 sm:px-6 sm:py-6">
            {loading && (
              <div className="space-y-3">
                {[...Array(7)].map((_, index) => (
                  <div
                    key={index}
                    className="h-16 animate-pulse rounded-2xl border border-gray-200 bg-gray-50"
                  />
                ))}
              </div>
            )}

            {!loading && error && (
              <div className="rounded-2xl border border-red-100 bg-red-50 px-4 py-10 text-center">
                <p className="text-sm text-red-600">
                  در دریافت سوالات متداول مشکلی پیش آمد. لطفاً بعداً دوباره تلاش
                  کنید.
                </p>
              </div>
            )}

            {!loading && !error && faqs.length === 0 && (
              <div className="rounded-2xl border border-gray-200 bg-gray-50 py-10 text-center">
                <p className="text-sm text-gray-500">
                  در حال حاضر سوالی ثبت نشده است.
                </p>
              </div>
            )}

            {!loading && !error && faqs.length > 0 && (
              <div className="space-y-3">
                {faqs.map((faq, index) => {
                  const isOpen = openIndex === index;

                  return (
                    <article
                      key={faq.id}
                      className={`overflow-hidden rounded-2xl border bg-white shadow-sm transition-colors duration-200 ${
                        isOpen ? "border-[#1E3A5F]/30" : "border-gray-200"
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => toggleAccordion(index)}
                        aria-expanded={isOpen}
                        aria-controls={`faq-answer-${faq.id}`}
                        className="flex w-full items-center justify-between gap-3 p-4 text-right transition-colors hover:bg-gray-50 focus:outline-none sm:p-5"
                      >
                        <span
                          className={`min-w-0 flex-1 text-sm font-medium md:text-base ${
                            isOpen ? "text-gray-900" : "text-gray-700"
                          }`}
                        >
                          {faq.question}
                        </span>

                        <span
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors duration-200 ${
                            isOpen
                              ? "bg-[#1E3A5F] text-[#FFC107]"
                              : "bg-gray-100 text-gray-500"
                          }`}
                        >
                          <FiChevronDown
                            className={`h-4 w-4 transition-transform duration-300 ${
                              isOpen ? "rotate-180" : ""
                            }`}
                          />
                        </span>
                      </button>

                      <div
                        id={`faq-answer-${faq.id}`}
                        className={`grid overflow-hidden transition-all duration-300 ease-in-out ${
                          isOpen
                            ? "grid-rows-[1fr] border-t border-gray-100"
                            : "grid-rows-[0fr]"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <div className="bg-gray-50/70 p-4 text-sm leading-8 text-gray-600 md:p-5 md:text-base">
                            {faq.answer}
                          </div>
                        </div>
                      </div>
                    </article>
                  );
                })}
              </div>
            )}
          </div>
        </section>
      </div>
    </main>
  );
};

export default FAQPage;
